import {useEffect, useState} from "react";
import {BreadCrumbs} from "../../../components/open/pages";
import {Link, useNavigate, useParams} from "react-router-dom";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {
    ThinAddIcon,
    ThinClassIcon,
    ThinCloseIcon,
    ThinCreditScoreIcon,
    ThinEditIcon,
    ThinInfoIcon, ThinnerSMSIcon,
    ThinPrintIcon,
    ThinSpecialIcon,
} from "../../../components/icons/material-icons";
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {GregorianToPersian} from "../../../components/techaran/date-convert";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {RemoveModal} from "../../../components/template/remove-modal";
import {AdminsPickAllowedStudentsForConsent} from "./pick-allowed";
import {SelectClassModal} from "../classes/select-class-modal";
import {AdminsAddEditConsentModal} from "./add-edit-consent";
import {ConfirmModal} from "../../../components/template/confirm-modal";

interface signupInterface {
    id: number,
    studentId: number,
    name: string,
    createdAt: string,
    class: string,
}

interface allowedInterface {
    studentId: number,
    name: string,
}

export const AdminsConsentDetailsScreen = () => {
    const {consentId} = useParams();
    const [data, setData] = useState({
        loaded: false,
        title: '',
        forAll: false,
        class: '',
        expiresAt: '2000-01-01 00:00:00',
        createdAt: '2000-01-01 00:00:00',
        signups: [] as signupInterface[],
        allowed: [] as allowedInterface[],
        specialIds: [] as number[],
        about:'',
        canAdd:false,
    });
    const navigate = useNavigate();
    const fetchData = () => {
        PostJSON(
            Apis.server + '/core/admins/consents/get',
            {
                consentId: consentId?.toString(),
            },
            true,
            (d: {
                result: string,
                reason: string,
                title: string,
                forAll: 0 | 1,
                class: string,
                expiresAt: string,
                createdAt: string,
                signups: signupInterface[] | null,
                allowed: allowedInterface[] | null,
                about:string,
                canAdd:boolean,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    else if(d.reason === 'access'){
                        ShowSnackbar(
                            'شما به این بخش دسترسی ندارید.',
                            'باشه',
                            5000,
                        );
                        navigate('/admins',{replace:true});
                    }
                    return;
                }
                let lst: number[] = [];
                if (d.allowed !== null)
                    d.allowed.forEach(e => {
                        lst.push(e.studentId);
                    });
                document.title = `${d.title} | رضایت‌نامه ها | اتوماسیون`;
                setData({
                    canAdd: d.canAdd,
                    loaded: true,
                    about: d.about,
                    title: d.title,
                    forAll: d.forAll === 1,
                    class: d.class,
                    expiresAt: d.expiresAt,
                    createdAt: d.createdAt,
                    signups: d.signups === null ? [] : d.signups,
                    allowed: d.allowed === null ? [] : d.allowed,
                    specialIds: lst,
                });
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        fetchData();
    }, []);
    const [tab, setTab] = useState('info' as 'info' | 'allowed' | 'paid');
    const [pickStudentsAllowed, setPickStudentsAllowed] = useState(false);
    const [removeAllowedStudent, setRemoveAllowedStudent] = useState({
        show: false,
        id: 0,
        name: '',
    });
    const [classSelected, setClassSelected] = useState({
        id: 0,
        title: '',
    });
    const [classModal, setClassModal] = useState(false);
    const fetchPayments = (classId: number, classTitle: string) => {
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/consents/print',
            {
                id: consentId as string,
                class: classId.toString(),
            },
            true,
            (d: {
                result: string,
                reason: string,
                list: signupInterface[] | null,
                title: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setClassSelected({
                    title: classTitle,
                    id: classId,
                });
                setData(v => {
                    let x = {...v};
                    x.signups = d.list === null ? [] : d.list;
                    return x;
                });
                window.scrollTo({top: 0, behavior: 'smooth'});
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    const [editModal, setEditModal] = useState(false);
    const [smsModal,setSmsModal] = useState(false);
    return (
        <>
            <BreadCrumbs links={[
                {title: 'اتوماسیون', url: '/admins/'},
                {title: 'رضایت‌نامه ها', url: '/admins/consents'},
                {title: data.loaded ? data.title : '...', url: `/admins/consents/view/${consentId}`},
            ]}/>
            {
                data.loaded ?
                    <div className="container" data-aos={"fade-up"} data-aos-duration={1000}>
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="d-none d-lg-block" style={{height: 60}}/>
                                <div className="student-profile">
                                    <b>{data.title}</b>
                                    <span>{data.forAll ? 'همگانی' : (data.class === '' ? 'افراد خاص' : `کلاس ${data.class}`)}</span>
                                </div>
                            </div>
                            <div className="col-lg-8">
                                <div className="open-tabbar" style={{marginTop: 20}}>
                                    <div className="open-tabbar-inner">
                                        <button onClick={() => {
                                            setTab('info');
                                            window.scrollTo({top: 0, behavior: 'smooth'});
                                        }} className={tab === 'info' ? 'active' : ''}>
                                            <ThinInfoIcon/>
                                            مشخصات
                                        </button>
                                        <button onClick={() => {
                                            setTab('allowed');
                                            window.scrollTo({top: 0, behavior: 'smooth'});
                                        }} className={tab === 'allowed' ? 'active' : ''}>
                                            <ThinSpecialIcon/>
                                            افراد مجاز
                                        </button>
                                        <button onClick={() => {
                                            setTab('paid');
                                            window.scrollTo({top: 0, behavior: 'smooth'});
                                        }} className={tab === 'paid' ? 'active' : ''}>
                                            <ThinCreditScoreIcon/>
                                            ثبت‌نام ها
                                        </button>
                                    </div>
                                </div>
                                {
                                    tab === 'info' ?
                                        <div className="screen-card">
                                            <div className="screen-card-header">
                                                <b>مشخصات رضایت‌نامه</b>
                                                <div className={"d-inline-flex align-items-center"} style={{gap:5}}>
                                                    <button onClick={()=>setSmsModal(true)}>
                                                        <ThinnerSMSIcon/>
                                                        <span>ارسال پیامک</span>
                                                    </button>
                                                    {
                                                        data.canAdd ?
                                                            <button onClick={() => setEditModal(true)}>
                                                                <ThinEditIcon/>
                                                                <span>ویرایش</span>
                                                            </button> : null
                                                    }
                                                </div>
                                            </div>
                                            <div className="student-info">
                                                <span>عنوان:</span>
                                                <b>{data.title}</b>
                                                <span>متن رضایت‌‌نامه:</span>
                                                <b>
                                                    <pre style={{whiteSpace:'normal'}}>{data.about}</pre>
                                                </b>
                                                <span>تاریخ پایان:</span>
                                                <b>{StringDigitsConvertToPersian(data.expiresAt.split(' ')[1] + " " + GregorianToPersian(data.expiresAt.split(' ')[0]).replaceAll('-', '/'))}</b>
                                                <span>تاریخ ایجاد:</span>
                                                <b>{StringDigitsConvertToPersian(data.createdAt.split(' ')[1] + " " + GregorianToPersian(data.createdAt.split(' ')[0]).replaceAll('-', '/'))}</b>
                                            </div>
                                        </div> :
                                        (
                                            tab === 'allowed' ?
                                                <div className={"screen-card"}>
                                                    <div className="screen-card-header">
                                                        <b>افراد خاص مجاز ثبت‌نام</b>
                                                        {
                                                            data.canAdd ?
                                                                <button onClick={() => setPickStudentsAllowed(true)}>
                                                                    <ThinAddIcon/>
                                                                    <span>افزودن</span>
                                                                </button> : null
                                                        }
                                                    </div>
                                                    <table
                                                        className="table open-table table-striped table-hover table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>دانش‌آموز</th>
                                                            <th>امکانات</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {
                                                            data.allowed.map((s, i) =>
                                                                <tr key={"SSx38dfks_s2EEfJv8" + i}>
                                                                    <td>{StringDigitsConvertToPersian(i + 1)}</td>
                                                                    <td>
                                                                        <Link
                                                                            to={`/admins/students/view/${s.studentId}`}>
                                                                            {s.name}
                                                                        </Link>
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            data.canAdd ?
                                                                                <button
                                                                                    onClick={() => setRemoveAllowedStudent({
                                                                                        show: true,
                                                                                        id: s.studentId,
                                                                                        name: s.name,
                                                                                    })} className={"open-tooltip"}>
                                                                                    <ThinCloseIcon/>
                                                                                    <i>حذف</i>
                                                                                </button> : '-'
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            )
                                                        }
                                                        </tbody>
                                                    </table>
                                                </div> :
                                                <div className={"screen-card"}>
                                                    <div className="screen-card-header">
                                                        <b>ثبت‌نام ها</b>
                                                        <div className="d-inline-flex align-items-center"
                                                             style={{gap: 10}}>
                                                            <button onClick={() => {
                                                                const _class = {...classSelected};
                                                                window.open(`/print/admins/consent-paper/${consentId}/${_class.id}`);
                                                            }}>
                                                                <ThinPrintIcon/>
                                                                <span>پرینت برگه‌ای</span>
                                                            </button>
                                                            <button onClick={() => {
                                                                const _class = {...classSelected};
                                                                window.open(`/print/admins/consent/${consentId}/${_class.id}`);
                                                            }}>
                                                                <ThinPrintIcon/>
                                                                <span>پرینت لیست</span>
                                                            </button>
                                                            <button onClick={() => setClassModal(true)}>
                                                                <ThinClassIcon/>
                                                                <span>{classSelected.id > 0 ? classSelected.title : 'همه کلاس‌ها'}</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <table
                                                        className="table open-table table-striped table-hover table-bordered">
                                                        <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>دانش‌آموز</th>
                                                            <th>کلاس</th>
                                                            <th>تاریخ</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {
                                                            data.signups.map((s, i) =>
                                                                <tr key={"K29jj39fFFFi_28DD" + i}>
                                                                    <td>{StringDigitsConvertToPersian(i + 1)}</td>
                                                                    <td>
                                                                        <Link
                                                                            to={`/admins/students/view/${s.studentId}`}>
                                                                            {s.name}
                                                                        </Link>
                                                                    </td>
                                                                    <td>{s.class === '' ? '-' : s.class}</td>
                                                                    <td>
                                                                        {StringDigitsConvertToPersian(s.createdAt.split(' ')[1] + " " + GregorianToPersian(s.createdAt.split(' ')[0]).replaceAll('-', '/'))}
                                                                    </td>
                                                                </tr>
                                                            )
                                                        }
                                                        </tbody>
                                                    </table>
                                                </div>
                                        )
                                }
                            </div>
                        </div>
                    </div> : null
            }
            <RemoveModal
                active={removeAllowedStudent.show}
                closeHandler={() => setRemoveAllowedStudent(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                title={"غیرمجاز سازی دانش‌آموز"}
                desc={"آیا مطمئن هستید می‌خواهید " + removeAllowedStudent.name + " را از لیست دانش‌آموزان مجاز این رضایت‌نامه حذف کنید؟"}
                onRemove={() => {
                    const x = {...removeAllowedStudent};
                    ShowProgressLoading();
                    PostJSON(
                        Apis.server + '/core/admins/consents/allowed/toggle',
                        {
                            consentId: consentId as string,
                            studentId: x.id.toString(),
                            allow: '0',
                        },
                        true,
                        (d: {
                            result: string,
                            reason: string | undefined,
                        }) => {
                            HideProgressLoading();
                            if (d.result !== 'OK') {
                                if (d.reason === 'login')
                                    AuthRedirectAdmins();
                                return;
                            }
                            ShowSnackbar(
                                'دانش‌آموز مورد نظر از لیست مجاز‌ها حذف شد.',
                                'باشه',
                                5000,
                            );
                            ShowProgressLoading();
                            fetchData();
                            window.scrollTo({top: 0, behavior: 'smooth'});
                        },
                        () => {
                        },
                        AuthRedirectAdmins,
                    ).then(void 0);
                }}
            />
            <AdminsPickAllowedStudentsForConsent
                active={pickStudentsAllowed}
                closeHandler={() => {
                    setPickStudentsAllowed(false);
                    ShowProgressLoading();
                    fetchData();
                }}
                consentId={consentId as string}
                specialList={data.specialIds}
                onDone={() => {
                    fetchData();
                    window.scrollTo({top: 0, behavior: 'smooth'});
                }}
            />
            <SelectClassModal
                active={classModal}
                closeHandler={() => setClassModal(false)}
                onSelected={(id: number, title: string) => {
                    // ShowProgressLoading();
                    setClassSelected({
                        title: "کلاس " + title,
                        id: id,
                    });
                    window.scrollTo({top: 0, behavior: 'smooth'});
                    fetchPayments(id, title);
                }}
            />
            <AdminsAddEditConsentModal
                active={editModal}
                closeHandler={() => setEditModal(false)}
                onDone={() => {
                    ShowProgressLoading();
                    fetchData();
                }}
                isEdit={true}
                consentId={parseInt(consentId as string)}
            />
            <ConfirmModal
                active={smsModal}
                closeHandler={() => setSmsModal(false)}
                title={"ارسال پیامک اطلاع‌رسانی"}
                desc={"آیا مطمئن هستید می‌خواهید به تمام دانش‌آموزان هدف، یک پیامک اطلاع‌رسانی ارسال کنید؟"}
                icon={<ThinnerSMSIcon/>}
                onOkay={() => {
                    ShowProgressLoading();
                    PostJSON(
                        Apis.server + '/core/admins/consents/sms',
                        {
                            id: consentId as string,
                        },
                        true,
                        (d: {
                            result: string,
                            reason: string,
                            count: number,
                        }) => {
                            HideProgressLoading();
                            if (d.result !== 'OK') {
                                if (d.reason === 'login')
                                    AuthRedirectAdmins();
                                return;
                            }
                            ShowSnackbar(
                                'تعداد ' + CurrencyFormat(d.count) + " پیامک ارسال گردید.",
                                'باشه',
                                5000,
                            );
                            setSmsModal(false);
                        },
                        () => {
                        },
                        AuthRedirectAdmins,
                    ).then(void 0);
                }}
            />
        </>
    );
};